/**
 * House interiors gallery — hotspots + mobile sheet.
 * Sticky left column stops under measured header (CSS).
 * Desktop: elegant popover on hover next to marker.
 * Mobile: bottom sheet on tap.
 * Scoped: [data-hi-gallery]
 */
(function () {
  'use strict';

  var instances = new WeakMap();
    var HOVER_CLOSE_MS = 280;

    function isMobile() {
      return window.matchMedia && window.matchMedia('(max-width: 767.98px)').matches;
    }

    function canHover() {
      return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    }

  function init(root) {
    if (!root || instances.has(root)) return;

    var sectionEl = root.closest('.shopify-section') || root.parentElement;
    var sheetRoot = sectionEl ? sectionEl.querySelector('[data-hi-gallery-sheet-root]') : null;
    var openHotspot = null;
    var lastFocus = null;
    var hoverCloseTimer = null;

    function clearPopoverPlacement(pop) {
      if (!pop) return;
      pop.classList.remove('is-fixed-overlay', 'is-left', 'is-right', 'is-above');
      pop.style.left = '';
      pop.style.top = '';
      pop.style.right = '';
      pop.style.bottom = '';
      pop.style.transform = '';
    }

    function positionPopover(hotspot, pop, stage) {
      clearPopoverPlacement(pop);
      pop.hidden = false;

      var align = hotspot.getAttribute('data-popover-align') || 'auto';
      var stageRect = stage.getBoundingClientRect();
      var hotRect = hotspot.getBoundingClientRect();
      var pad = 12;
      var needW = 270;

      if (align === 'left') {
        pop.classList.add('is-left');
      } else if (align === 'right') {
        pop.classList.add('is-right');
      } else {
        var spaceRight = stageRect.right - hotRect.right;
        var spaceLeft = hotRect.left - stageRect.left;
        if (spaceRight >= needW) {
          pop.classList.add('is-right');
        } else if (spaceLeft >= needW) {
          pop.classList.add('is-left');
        } else if (spaceLeft > spaceRight) {
          pop.classList.add('is-left');
        } else {
          pop.classList.add('is-right');
        }
      }

      var popRect = pop.getBoundingClientRect();

      if (popRect.bottom > Math.min(stageRect.bottom, window.innerHeight) - pad) {
        pop.classList.add('is-above');
        popRect = pop.getBoundingClientRect();
      }

      if (popRect.left < stageRect.left + pad) {
        pop.classList.remove('is-left');
        pop.classList.add('is-right');
      }
      if (popRect.right > stageRect.right - pad) {
        pop.classList.remove('is-right');
        pop.classList.add('is-left');
      }
    }

    function closeAll() {
      if (hoverCloseTimer) {
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      }
      Array.prototype.forEach.call(root.querySelectorAll('[data-hi-gallery-hotspot].is-open'), function (h) {
        h.classList.remove('is-open');
        var btn = h.querySelector('[data-hi-gallery-marker]');
        var pop = h.querySelector('[data-hi-gallery-popover]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
        if (pop) {
          pop.hidden = true;
          clearPopoverPlacement(pop);
        }
      });
      if (sheetRoot) {
        sheetRoot.hidden = true;
        var sheet = sheetRoot.querySelector('[data-hi-gallery-sheet]');
        if (sheet) sheet.innerHTML = '';
      }
      openHotspot = null;
      if (lastFocus && lastFocus.focus) {
        try {
          lastFocus.focus();
        } catch (e) {}
      }
      lastFocus = null;
      document.removeEventListener('keydown', onDocKey);
      document.removeEventListener('pointerdown', onDocPointer, true);
      window.removeEventListener('scroll', onReposition, true);
      window.removeEventListener('resize', onReposition);
    }

    function onReposition() {
      if (!openHotspot || isMobile()) return;
      var pop = openHotspot.querySelector('[data-hi-gallery-popover]');
      var stage = openHotspot.closest('[data-hi-gallery-stage]');
      if (pop && stage && !pop.hidden) positionPopover(openHotspot, pop, stage);
    }

    function openHotspotEl(hotspot, opts) {
      var asSheet = opts && opts.sheet;
      var btn = hotspot.querySelector('[data-hi-gallery-marker]');
      var pop = hotspot.querySelector('[data-hi-gallery-popover]');
      var stage = hotspot.closest('[data-hi-gallery-stage]');
      if (!btn || !pop) return;

      if (hoverCloseTimer) {
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      }

      if (openHotspot === hotspot && hotspot.classList.contains('is-open') && !asSheet) {
        return;
      }

      closeAll();
      lastFocus = btn;
      openHotspot = hotspot;
      hotspot.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');

      if (asSheet && sheetRoot) {
        var sheet = sheetRoot.querySelector('[data-hi-gallery-sheet]');
        var clone = pop.cloneNode(true);
        clone.hidden = false;
        clone.removeAttribute('id');
        clearPopoverPlacement(clone);
        if (sheet) {
          sheet.innerHTML = '';
          sheet.appendChild(clone);
        }
        sheetRoot.hidden = false;
        if (sheet && sheet.focus) sheet.focus();
      } else if (stage) {
        positionPopover(hotspot, pop, stage);
        window.addEventListener('scroll', onReposition, true);
        window.addEventListener('resize', onReposition);
      }

      document.addEventListener('keydown', onDocKey);
      document.addEventListener('pointerdown', onDocPointer, true);
    }

    function scheduleHoverClose() {
      if (hoverCloseTimer) clearTimeout(hoverCloseTimer);
      hoverCloseTimer = setTimeout(function () {
        hoverCloseTimer = null;
        closeAll();
      }, HOVER_CLOSE_MS);
    }

    function cancelHoverClose() {
      if (hoverCloseTimer) {
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      }
    }

    function onDocKey(e) {
      if (e.key === 'Escape') {
        e.preventDefault();
        closeAll();
      }
    }

    function onDocPointer(e) {
      if (!openHotspot) return;
      if (openHotspot.contains(e.target)) return;
      var pop = openHotspot.querySelector('[data-hi-gallery-popover]');
      if (pop && pop.contains(e.target)) return;
      if (sheetRoot && !sheetRoot.hidden && sheetRoot.contains(e.target)) {
        if (e.target.matches('[data-hi-gallery-sheet-backdrop]')) closeAll();
        return;
      }
      closeAll();
    }

    function onRootClick(e) {
      if (e.target.closest('[data-hi-gallery-close]')) {
        e.preventDefault();
        closeAll();
        return;
      }
      var marker = e.target.closest('[data-hi-gallery-marker]');
      if (!marker || !root.contains(marker)) return;

      /* Desktop: click marker toggles; click outside / close closes */
      if (canHover() && !isMobile()) {
        e.preventDefault();
        var hotspotHover = marker.closest('[data-hi-gallery-hotspot]');
        if (!hotspotHover) return;
        if (hotspotHover.classList.contains('is-open')) closeAll();
        else openHotspotEl(hotspotHover, { sheet: false });
        return;
      }

      e.preventDefault();
      var hotspot = marker.closest('[data-hi-gallery-hotspot]');
      if (!hotspot) return;
      if (hotspot.classList.contains('is-open')) closeAll();
      else openHotspotEl(hotspot, { sheet: true });
    }

    function bindHotspotHover(hotspot) {
      if (hotspot.getAttribute('data-hi-hover-bound') === 'true') return;
      hotspot.setAttribute('data-hi-hover-bound', 'true');
      hotspot.addEventListener('mouseenter', function () {
        if (!canHover() || isMobile()) return;
        cancelHoverClose();
        if (openHotspot === hotspot) return;
        openHotspotEl(hotspot, { sheet: false });
      });
    }

    Array.prototype.forEach.call(root.querySelectorAll('[data-hi-gallery-hotspot]'), bindHotspotHover);

    function onBlockSelect(ev) {
      var blockId = ev.detail && ev.detail.blockId;
      if (!blockId) return;
      var hotspot = root.querySelector('[data-hotspot-id="' + blockId + '"]');
      root.querySelectorAll('.is-editor-selected').forEach(function (el) {
        el.classList.remove('is-editor-selected');
      });
      if (hotspot) {
        hotspot.classList.add('is-editor-selected');
        hotspot.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
        if (!isMobile()) openHotspotEl(hotspot, { sheet: false });
      }
    }

    function onBlockDeselect() {
      root.querySelectorAll('.is-editor-selected').forEach(function (el) {
        el.classList.remove('is-editor-selected');
      });
      closeAll();
    }

    root.addEventListener('click', onRootClick);
    document.addEventListener('shopify:block:select', onBlockSelect);
    document.addEventListener('shopify:block:deselect', onBlockDeselect);

    if (sheetRoot) {
      sheetRoot.addEventListener('click', function (e) {
        if (e.target.closest('[data-hi-gallery-close]') || e.target.matches('[data-hi-gallery-sheet-backdrop]')) {
          closeAll();
        }
      });
    }

    if (sectionEl) {
      sectionEl.style.overflow = 'visible';
    }

    instances.set(root, {
      destroy: function () {
        closeAll();
        root.removeEventListener('click', onRootClick);
        document.removeEventListener('shopify:block:select', onBlockSelect);
        document.removeEventListener('shopify:block:deselect', onBlockDeselect);
      }
    });
  }

  function destroy(root) {
    var inst = instances.get(root);
    if (inst && inst.destroy) inst.destroy();
    instances.delete(root);
  }

  function boot(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-hi-gallery]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) boot(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target) return;
    var root = e.target.querySelector('[data-hi-gallery]');
    if (root) destroy(root);
  });
})();
